import { getApiBaseUrl } from './config';

/**
 * Same contract as Leveltry app: GET /api/legal/:docKey?locale=en|es|pt
 */
export async function fetchLegalDocument(docKey, locale) {
  const base = getApiBaseUrl();
  const params = new URLSearchParams({ locale });
  const url = `${base}/api/legal/${docKey}?${params.toString()}`;

  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const message =
      payload?.message || `Error loading legal document (${response.status})`;
    throw new Error(message);
  }

  if (!payload?.body) {
    throw new Error(payload?.message || 'Legal document is empty');
  }

  return payload;
}
